<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称">
              <global-select
                :value.sync="queryParams.scheduleNameList"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpScheduleNames/scheduleNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划类型">
              <global-select
                :value.sync="queryParams.scheduleType"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MS_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMrpScheduleNamesNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpMrpScheduleNames:add']">新建</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpScheduleNames:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.DMS_MPS_NAME_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpScheduleNames:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpMrpScheduleNames:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" valueFormat="YYYY-MM-DD HH:mm:ss" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dms-mps-name-add
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiUpdateScpMrpScheduleNames, apiDelScpMrpScheduleNames, apiScpMrpScheduleNamesListTwo, apiScpMrpScheduleNamesNewExport } from '@/api/scp/planSetting/dms-mps-name'
import DmsMpsNameAdd from './components/dms-mps-name-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Dms-mps-name', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal,
    DmsMpsNameAdd
  },
  data () {
    return {
      apiScpMrpScheduleNamesNewExport,
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpScheduleNamesListTwo, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        scheduleNameList: undefined,
        scheduleType: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '计划名称',
          dataIndex: 'scheduleName',
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' },
          ellipsis: true,
          align: 'center',
          type: "input"
        },
        {
          title: '计划类型',
          dataIndex: 'scheduleTypeName',
          align: 'center'
        },
        {
          title: '失效时间',
          dataIndex: 'disableDate',
          scopedSlots: { customRender: 'disableDate' },
          align: 'center',
          type: "date"
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created () {},
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false;
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 删除
    handleDelete (row) {
      // if (!row.cccccccccccc) {
      //   this.$error({
      //     content: '错误：该计划未失效，删除计划前需先失效计划。',
      //     okText: "确定"
      //   })
      //   return
      // }
      const self = this
      this.$confirm({
        title: '您确定要删除这行内容吗？',
        content: `注：删除计划将同时删除对应的MDS/MPS条目`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiDelScpMrpScheduleNames(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      apiUpdateScpMrpScheduleNames(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        scheduleNameList: undefined,
        scheduleType: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpScheduleNames/export', {
      //   ...this.queryParams
      // }, `MDS/MPS名称_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
</style>
